import Service, { inject as service } from '@ember/service';

export default class ClassificationCommands extends Service {
  @service api;
  @service shData;

  loadClassifications({
    count = 500,
    includes = [],
    filters = {},
  } = {}) {
    const options = {
      params: {
        count,
        filter: filters,
        sortOrder: 'asc',
      }
    };

    this.shData.addIncludesToOptions(options, includes);

    return this.api.request('classifications', options).then((response) => {
      this.shData.pushResponseToStore(response);
      return this.shData.getModelArrayFromResponse(response, 'classification');
    });
  }

  createClassification(label, category, type) {
    const options = {
      jsonData: {
        type,
        category,
        label,
      },
    };

    return this.api.post('classifications', options);
  }

  updateClassification(id, label, type) {
    const options = {
      jsonData: {},
    };

    if (type !== null) {
      options.jsonData['type'] = type;
    }


    if (label) {
      options.jsonData['label'] = label;
    }

    return this.api.put(`classifications/${id}`, options);
  }

  deleteClassification(id) {
    return this.api.delete(`classifications/${id}`, {});
  }
}
